import "%modules%/header/header";
import "%modules%/slider/slick";
import "%modules%/scenari/scenari";
import "%modules%/configurator/configurator";
import "%modules%/guide/guide";
import "%modules%/modal/modal";